import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import common from '@/request/api/common'

const homePage = {
    // 首页模块获取所有模块信息
    async getHomePageModuleInfo (params) {
        const userDetailInfo = await common.getUser() || {}
        params.userId = userDetailInfo.userId || 0
        return axios.post('/goods/home_page/getHomePageModuleInfo', qs.stringify(params));
    },
    //获取首页商品推荐位列表
    getRecommendGoodsList (params) {
        return axios.post('/goods/mobileGoods/getRecommendGoodsList', qs.stringify(params));
    },
    // 根据appid获取企业信息
    getCompanyComfigByAppId (params) {
        return axios.post('/goods/mobileUser/getCompanyComfigByAppId', qs.stringify(params));
    },
    // 订货端对接版根据openId获取客户信息
    getReceptionUserInfoDockOpenId (params) {
        return axios.post('/order/companyConfiguration/getReceptionUserInfoDockOpenId', qs.stringify(params));
    },
    // 订货端对接版解绑客户信息openId
    unbindingReceptionUserInfoDockOpenId (params) {
        return axios.post('/order/companyConfiguration/unbindingReceptionUserInfoDockOpenId', qs.stringify(params));
    },
}

export default homePage;


// WEBPACK FOOTER //
// ./src/request/api/homePage/homePage.js